import { render, staticRenderFns } from "./billingRate.vue?vue&type=template&id=6b48f7a0&"
import script from "./billingRate.vue?vue&type=script&lang=js&"
export * from "./billingRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b48f7a0')) {
      api.createRecord('6b48f7a0', component.options)
    } else {
      api.reload('6b48f7a0', component.options)
    }
    module.hot.accept("./billingRate.vue?vue&type=template&id=6b48f7a0&", function () {
      api.rerender('6b48f7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/billingRate.vue"
export default component.exports